import React from 'react';
import { StyledBrokerageFilter, StyledClearSearch } from './StyledComponents';

interface BrokeragesListFilter {
  setFilterText: (value: string) => void;
  filterText: string;
}

const BrokeragesListFilter: React.FC<BrokeragesListFilter> = ({
  setFilterText,
  filterText,
}) => (
  <div className="normalheader transition animated fadeIn">
    <div className="hpanel">
      <div className="panel-body">
        <h2 className="font-light m-b-xs">Find a Brokerage</h2>
        <StyledBrokerageFilter id="brokerage-filter" autoComplete="off">
          <input
            className="pull-right"
            onChange={e => setFilterText(e.target.value)}
            placeholder="&#xF002; Search brokerages by name or OID"
            style={{ fontFamily: 'Open Sans, FontAwesome' }}
            type="text"
            value={filterText}
          />
          <StyledClearSearch
            onClick={() => setFilterText('')}
            id="clear-search"
            className="fa fa-times-circle"
          />
        </StyledBrokerageFilter>
      </div>
    </div>
  </div>
);

export default BrokeragesListFilter;
